import * as React from "react";
const SvgWhiteDownload = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m12.5 8.75-.746 1.864A3 3 0 0 1 8.97 12.5H4.03a3 3 0 0 1-2.785-1.886L.5 8.75m2.978-2.062 3 2.812m0 0 3-2.812m-3 2.812v-9"
    />
  </svg>
);
export default SvgWhiteDownload;
